/** Survives an offline reload. The attempt draft stores the same value. */
export const CLOCK_OFFSET_KEY = 'lms:attempt:v1:clock-offset';

/** Offset such that clientNow + offset ≈ serverNow. */
export function clockOffsetMs(serverNowIso: string, clientNowMs = Date.now()): number {
  const server = Date.parse(serverNowIso);
  if (Number.isNaN(server)) return 0;
  return server - clientNowMs;
}

export function rememberServerNow(
  serverNowIso: string,
  clientNowMs = Date.now(),
  storage?: Pick<Storage, 'setItem'> | null,
): number {
  const offset = clockOffsetMs(serverNowIso, clientNowMs);
  const target = storage === undefined ? (typeof localStorage === 'undefined' ? null : localStorage) : storage;
  try {
    target?.setItem(CLOCK_OFFSET_KEY, String(offset));
  } catch {
    // Private mode.
  }
  return offset;
}

export function readClockOffset(storage?: Pick<Storage, 'getItem'> | null): number {
  const target = storage === undefined ? (typeof localStorage === 'undefined' ? null : localStorage) : storage;
  const raw = target?.getItem(CLOCK_OFFSET_KEY);
  const value = raw == null ? 0 : Number(raw);
  return Number.isFinite(value) ? value : 0;
}

export function remainingUntilDeadline(
  deadlineIso: string | null | undefined,
  offsetMs: number,
  clientNowMs = Date.now(),
): number | null {
  if (!deadlineIso) return null;
  const deadline = Date.parse(deadlineIso);
  if (Number.isNaN(deadline)) return null;
  const serverNow = clientNowMs + offsetMs;
  return Math.max(0, Math.floor((deadline - serverNow) / 1000));
}
